var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBelize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 168.139 467.731 90.6261 400.287 44.5221L256 33.3911L111.713 44.5211C44.27 90.6261 0 168.14 0 256C0 343.863 44.27 421.374 111.713 467.478L256 478.609L400.287 467.479C467.731 421.374 512 343.863 512 256Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.287 44.522C359.202 16.436 309.524 0 256 0C202.477 0 152.798 16.436 111.713 44.522H400.287Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.713 467.478C152.797 495.564 202.477 512 256 512C309.524 512 359.202 495.564 400.287 467.478H111.713Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 378.435C323.619 378.435 378.435 323.619 378.435 256C378.435 188.381 323.619 133.565 256 133.565C188.381 133.565 133.565 188.381 133.565 256C133.565 323.619 188.381 378.435 256 378.435Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 356.174C311.325 356.174 356.174 311.325 356.174 256C356.174 200.676 311.325 155.826 256 155.826C200.676 155.826 155.826 200.676 155.826 256C155.826 311.325 200.676 356.174 256 356.174Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 322.783C292.883 322.783 322.783 292.883 322.783 256C322.783 219.117 292.883 189.217 256 189.217C219.117 189.217 189.217 219.117 189.217 256C189.217 292.883 219.117 322.783 256 322.783Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 239.304L219.826 256V283.826L256 306.087L292.174 283.826V256L256 239.304Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.826 222.609H292.174V256H219.826V222.609Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelize);
export default __webpack_public_path__ + "static/media/belize.de493a17308ffce9d7705939df8bb962.svg";
export { ForwardRef as ReactComponent };